import React, { PureComponent } from "react";
import _ from "lodash";
import { branch } from "baobab-react/higher-order";
import PropTypes from "baobab-react/prop-types";

import { FontAwesomeIcon } from "./FontAwesomeIconWrapper";

import Clock from "../Clock";
import ToggleMiraSpeaking from "../shared/button/ToggleMiraSpeaking";

import * as Utils from "../../utils/utils";

import * as playerActions from "../../actions/playerActions";
import * as alertActions from "../../actions/alertActions";

import SyntheticVoiceApi from "../../speech/SyntheticVoiceApi";

class QuickToolbar extends PureComponent {
	
	render() {

		// let submitLabel;

		// if (this.props.submitLabel) {
		// 	submitLabel = this.props.submitLabel;
		// }
		// console.log("RENDER QuickToolbar ", this.props);


		const { showSideMenuOpen, sideMenuOpenAction, showSaveActions, showSubmitButton} = this.props;
		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		const { quickBar: quickBarTheme } = theme;
		const showSideMenuOpenIcon = showSideMenuOpen && sideMenuOpenAction;

		const currentActivity = this.context.tree.get(["activity"]);

		console.log("quickBarTheme container",quickBarTheme);
		let containerStyles = quickBarTheme ? quickBarTheme.container : {
			flex: 0,
			alignItems: "center",
			justifyContent: "space-between",
			backgroundColor: "black",
			padding: 5,
			position: "relative",
			height: "100%",
			width: "100%",
			display: "flex",
			flexDirection: "row",
			paddingLeft: 10,
			paddingRight: 10
		};
		
		if (this.props.backgroundColor) {
			containerStyles = _.assign({}, containerStyles, { backgroundColor: this.props.backgroundColor });
		}
		return (
			<div style={containerStyles}>
				<div style={{ flexDirection: "row", flex: 2, display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
					

					{showSaveActions &&
						<div style={{ flexDirection: "row", justifyContent: "flex-end", flex: 1, display: "flex", alignItems: "flex-end" }}>

							{showSubmitButton && <div onClick={() => {
								alertActions.showYesNo(									
									"Are you sure you want to submit the activity?\n\nYou will NOT be able to resume if you have further changes.",
									"Submit + Exit Activity",
									() => {
										this.context.tree.set(["activity", "submitted"], Utils.getUtcTimestamp());
										this.props.dispatch(
											playerActions.saveActivityAndExit,
											true
										);
									}
								);
							}}
								style={{ justifyContent: "center", alignItems: "center", borderRadius: 5, width: 100, padding: 4, flexDirection: "row", marginRight: 8, marginLeft: 8, cursor:"pointer" }}
							>
								{/* <Text style={{ fontSize: 16, color: "royalblue" }}>Save</Text> */}
								<FontAwesomeIcon icon="check" style={{ fontSize: 20, color: "lightgreen", marginRight: 4 }} /><span style={{ fontSize: 16, color: "lightgreen" }}>Submit</span>
							</div>}


							{(!Utils.isPublished() && this.props.persistenceType.toLowerCase() !== "default") &&
								<div onClick={() => {
									alertActions.showYesNo(
										"Are you sure you want to exit the activity?\n\nYou will be able to resume if you have further changes.",
										"Exit Activity",									
										() => {
											this.props.dispatch(
												playerActions.saveActivityAndExit
											);
										}
									);
								}}
									style={{ display: "flex", backgroundColor: "royalblue", justifyContent: "center", alignItems: "center", borderRadius: 5, width: 40, padding: 4, marginLeft: 8, marginRight: 8, flexDirection: "row", cursor:"pointer" }}
								>
									{/* <Text style={{ fontSize: 16, color: "royalblue" }}>Save</Text> */}
									<FontAwesomeIcon icon="home" style={{ fontSize: 20, color: "white" }} />
								</div>
							}
						</div>}				
					<ToggleMiraSpeaking onPress={() => { 
							if (SyntheticVoiceApi.isSpeaking()) {
								SyntheticVoiceApi.stop();
								this.context.tree.set(["miraSpeaking"], false);
							} else {
								console.log("Tap speak selected item");
								playerActions.speakSelectedItem(this.context.tree); 
							}
 						}} />


						<div onClick={() => {
							if (this.props.audio) {
								SyntheticVoiceApi.stop();
							}
							this.props.dispatch(
								playerActions.toggleAudio
							);
						}} style={{ marginLeft: 8, marginRight: 9 }}>
							<div style={{ alignItems: "center", justifyContent: "center" }}>
								<div style={{ color: this.props.audio ? "lightgreen" : "white", cursor: "pointer" }}><FontAwesomeIcon icon={this.props.audio ? ["fas","volume-up"] : "volume-slash"} size={20} /></div>
							</div>
						</div>


						{this.props.showClock &&
							<div onClick={() => { this.props.dispatch(playerActions.setLogbookModalVisible, true); }} style={{ marginLeft: 8, marginRight: 8, cursor: "pointer" }}>
								<Clock />
							</div>
						}



						{(currentActivity && currentActivity.allowSwitchToShowMode) &&
							<div onClick={() => {
								// SyntheticVoiceApi.stop();
								this.props.dispatch(
									playerActions.showShowMode
								);
							}} style={{ marginLeft: 8, marginRight: 8 }}>
								<div style={{ alignItems: "center", justifyContent: "center" }}>
									<div style={{ color: "white", cursor: "pointer" }}><FontAwesomeIcon icon="image" size={20} /></div>
								</div>
							</div>
						}

						{showSideMenuOpenIcon && <div style={{ marginRight: 8, marginLeft: 8, cursor: "pointer" }} onClick={sideMenuOpenAction}>						
							<FontAwesomeIcon style={{ fontSize: 20, color: "white" }} icon={["fas", "bars"]} />						
						</div>}				
					

				</div>
			</div>
		);
	}
}

QuickToolbar.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	dimensions: ["dimensions"],
	content: ["content"],
	submitLabel: ["activity","submitLabel"],
	user: ["user"],
	audio: ["appPreferences","voice","audio"],
	tracking: ["tracking"],
	interruptMira: ["interruptMira"],
	miraSpeaking: ["miraSpeaking"],
	storeCloudHistory: ["storeCloudHistory"],
	instances: ["instances"],
	connection: ["connection"],
	activityTheme: ["activity", "theme"],
	dictation:["appState","dictation","active"],
	persistenceType: ["appState", "targetConfig", "type"]
}, QuickToolbar);